import React, { useState } from "react";
import { getDensity, setDensity } from "@/lib/density";

// Comutator „Afișare compactă / normală”, mereu în colțul din dreapta-sus (compact = 85% din normal).
// `inline`: în bara de sus a aspectului portocaliu; altfel plutește fix în colțul ferestrei.
export default function DensityToggle({ inline = false }) {
  const [density, setDensityState] = useState(getDensity);
  const onClick = () => setDensityState(d => { const n = d === "compact" ? "normal" : "compact"; setDensity(n); return n; });
  return (
    <button type="button" className={`density-toggle${inline ? " inline" : ""}`} data-testid="density-toggle"
      title="Schimbă între afișarea compactă (85%) și cea normală" onClick={onClick}>
      Afișare: {density === "compact" ? "compactă" : "normală"}
    </button>
  );
}
